var layer = null;
var active = false;
var desired = false;
var controller = null;

export const kowrLayerRuntime = {
    getLayer: function() { return layer; },
    setLayer: function(value) { layer = value; },
    getActive: function() { return active; },
    setActive: function(value) { active = !!value; },
    getDesired: function() { return desired; },
    setDesired: function(value) { desired = !!value; },
    getController: function() { return controller; },
    setController: function(value) { controller = value; },
    getState: function() {
        return {
            kowrActive: active,
            kowrDesired: desired,
        };
    },
};
